/**
 * Thin, defensive wrapper around localStorage.
 *
 * Reads/writes are wrapped in try/catch because storage can throw (private
 * mode, quota, SSR). Values are JSON-encoded so callers can persist objects.
 */
export const storage = {
  get(key) {
    try {
      const raw = window.localStorage.getItem(key);
      return raw == null ? null : JSON.parse(raw);
    } catch {
      return null;
    }
  },

  set(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* ignore write failures */
    }
  },

  remove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};
